// Neutral fallback color shared by every StatusPill.vue caller (#1616) —
// used for a missing row or an unrecognized value, instead of each
// composable/component re-declaring the same literal.
export const NEUTRAL_PILL_CLASS = 'bg-white/10 text-white/50'
